export default {
  isShow: false,
  status: 'success',
  timeout: 5000,
  message: '',
}
